import script from "./SmLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./SmLoader.vue?vue&type=script&lang=ts&setup=true"

import "./SmLoader.vue?vue&type=style&index=0&id=4ec7b12f&lang=scss"
import "./SmLoader.vue?vue&type=style&index=1&id=4ec7b12f&lang=scss"

const __exports__ = script;

export default __exports__